window.addEventListener('load', function () {
  const cta = document.querySelector('.sticky-product-cta');

  if (!cta) return;

  const placeholder = document.createElement('div');
  placeholder.style.display = 'none';

  cta.parentNode.insertBefore(placeholder, cta);

  // Real original position of the CTA in the document
  let ctaOriginalTop = cta.getBoundingClientRect().top + window.scrollY;

  function handleStickyCTA() {
    if (window.scrollY >= ctaOriginalTop) {

      if (!cta.classList.contains('is-fixed')) {
        placeholder.style.height = cta.offsetHeight + 'px';
        placeholder.style.display = 'block';

        cta.classList.add('is-fixed');
      }

    } else {

      if (cta.classList.contains('is-fixed')) {
        cta.classList.remove('is-fixed');

        placeholder.style.display = 'none';
        placeholder.style.height = '0';
      }
    }
  }

  window.addEventListener('scroll', handleStickyCTA, {
    passive: true
  });

  handleStickyCTA();
});


/*Cards side scrolling*/
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.product-features-scroll').forEach(function (slider) {

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    slider.addEventListener('pointerdown', function (e) {

      if (window.innerWidth >= 768) return;

      isDragging = true;

      startX = e.clientX;
      startScrollLeft = slider.scrollLeft;

      slider.classList.add('is-dragging');

      slider.setPointerCapture(e.pointerId);
    });


    slider.addEventListener('pointermove', function (e) {

      if (!isDragging) return;

      const deltaX = e.clientX - startX;

      slider.scrollLeft = startScrollLeft - deltaX;

      e.preventDefault();
    });


    function stopDragging(e) {

      if (!isDragging) return;

      isDragging = false;

      slider.classList.remove('is-dragging');

      if (
        e &&
        slider.hasPointerCapture(e.pointerId)
      ) {
        slider.releasePointerCapture(e.pointerId);
      }

    }


    slider.addEventListener('pointerup', stopDragging);

    slider.addEventListener('pointercancel', stopDragging);

  });

});